<template>
  <div class="card">
    <div class="header">
      <h1 class="Title">Statistics</h1>
      <font-awesome-icon icon="times" @click="close" class="x" />
    </div>
    <div class="cardHeader">
      <div class="cardHeaderItem">
        <div class="icono">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="37"
              height="37"
              viewBox="0 0 37 37"
            >
              <path
                id="clock-regular"
                d="M26.5,8A18.5,18.5,0,1,0,45,26.5,18.5,18.5,0,0,0,26.5,8Zm0,33.419A14.919,14.919,0,1,1,41.419,26.5,14.915,14.915,0,0,1,26.5,41.419Zm4.61-7.788-6.333-4.6a.9.9,0,0,1-.366-.724V16.056a.9.9,0,0,1,.9-.9h2.387a.9.9,0,0,1,.9.9v10.57l4.983,3.625a.9.9,0,0,1,.194,1.253l-1.4,1.932a.9.9,0,0,1-1.253.194Z"
                transform="translate(-8 -8)"
                fill="#238ef6"
              />
            </svg>
          </div>
        </div>
        <div class="BodyItem">
          <div class="TitleItem">
            <p>Total Hours Contracted</p>
          </div>
          <div class="BodyValues">
            <h3 class="Value">{{ projects[0].Contrated }}</h3>
            <span class="Percent"></span>
          </div>
        </div>
      </div>
      <div class="cardHeaderItem">
        <div class="icono">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="37"
              height="37"
              viewBox="0 0 37 37"
            >
              <path
                id="clock-regular"
                d="M26.5,8A18.5,18.5,0,1,0,45,26.5,18.5,18.5,0,0,0,26.5,8Zm0,33.419A14.919,14.919,0,1,1,41.419,26.5,14.915,14.915,0,0,1,26.5,41.419Zm4.61-7.788-6.333-4.6a.9.9,0,0,1-.366-.724V16.056a.9.9,0,0,1,.9-.9h2.387a.9.9,0,0,1,.9.9v10.57l4.983,3.625a.9.9,0,0,1,.194,1.253l-1.4,1.932a.9.9,0,0,1-1.253.194Z"
                transform="translate(-8 -8)"
                fill="#238ef6"
              />
            </svg>
          </div>
        </div>
        <div class="BodyItem">
          <div class="TitleItem">
            <p>Total Hours Data Analysis</p>
          </div>
          <div class="BodyValues">
            <h3 class="Value">124</h3>
            <span class="Percent">78%</span>
          </div>
        </div>
      </div>
      <div class="cardHeaderItem">
        <div class="icono">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="37"
              height="37"
              viewBox="0 0 37 37"
            >
              <path
                id="clock-regular"
                d="M26.5,8A18.5,18.5,0,1,0,45,26.5,18.5,18.5,0,0,0,26.5,8Zm0,33.419A14.919,14.919,0,1,1,41.419,26.5,14.915,14.915,0,0,1,26.5,41.419Zm4.61-7.788-6.333-4.6a.9.9,0,0,1-.366-.724V16.056a.9.9,0,0,1,.9-.9h2.387a.9.9,0,0,1,.9.9v10.57l4.983,3.625a.9.9,0,0,1,.194,1.253l-1.4,1.932a.9.9,0,0,1-1.253.194Z"
                transform="translate(-8 -8)"
                fill="#238ef6"
              />
            </svg>
          </div>
        </div>
        <div class="BodyItem">
          <div class="TitleItem">
            <p>Total Hours Peer Review</p>
          </div>
          <div class="BodyValues">
            <h3 class="Value">36</h3>
            <span class="Percent">22%</span>
          </div>
        </div>
      </div>
      <div class="cardHeaderItem">
        <div class="icono">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="37"
              height="37"
              viewBox="0 0 37 37"
            >
              <path
                id="clock-regular"
                d="M26.5,8A18.5,18.5,0,1,0,45,26.5,18.5,18.5,0,0,0,26.5,8Zm0,33.419A14.919,14.919,0,1,1,41.419,26.5,14.915,14.915,0,0,1,26.5,41.419Zm4.61-7.788-6.333-4.6a.9.9,0,0,1-.366-.724V16.056a.9.9,0,0,1,.9-.9h2.387a.9.9,0,0,1,.9.9v10.57l4.983,3.625a.9.9,0,0,1,.194,1.253l-1.4,1.932a.9.9,0,0,1-1.253.194Z"
                transform="translate(-8 -8)"
                fill="#238ef6"
              />
            </svg>
          </div>
        </div>
        <div class="BodyItem">
          <div class="TitleItem">
            <p>Total Hours Remaining</p>
          </div>
          <div class="BodyValues">
            <h3 class="Value">0</h3>
            <span class="Percent">0%</span>
          </div>
        </div>
      </div>
    </div>
    <div class="cardBody">
      <div class="cardBodyItem">
        <div class="TitleCardBodyItem">
          <h3>Total Hours per Phase</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="40"
            height="5"
            viewBox="0 0 32 4"
            class="svgCardBody"
          >
            <defs>
              <linearGradient
                id="linear-gradient"
                x1="0.984"
                y1="0.154"
                x2="0"
                y2="0.823"
                gradientUnits="objectBoundingBox"
              >
                <stop offset="0" stop-color="#7467f0" />
                <stop offset="1" stop-color="#2896e9" />
              </linearGradient>
            </defs>
            <rect
              id="Rectángulo_16838"
              data-name="Rectángulo 16838"
              width="32"
              height="4"
              rx="2"
              fill="url(#linear-gradient)"
            />
          </svg>
        </div>
        <div class="cardBodyCombos">
          <p class="ElementoCombo">from</p>
          <p class="ElementoCombo">{{ pickerhffrom }}</p>
          <font-awesome-icon
            class="ElementoCombo flecha"
            icon="sort-down"
            @click="fromhf = !fromhf"
          />
          <div class="pickerFrom" v-if="fromhf">
            <v-date-picker
              v-model="pickerhffrom"
              @input="(fromhf = false), cargar()"
              :min="getMinMaxDates.minDate"
              :max="getMinMaxDates.maxDate"
            ></v-date-picker>
          </div>
          <p class="ElementoCombo">to</p>
          <p class="ElementoCombo">{{ pickerhfto }}</p>
          <font-awesome-icon
            class="ElementoCombo flecha"
            icon="sort-down"
            @click="tohf = !tohf"
          />
          <div class="pickerFrom" v-if="tohf">
            <v-date-picker
              v-model="pickerhfto"
              header-color="#238ef6"
              @input="tohf = false"
              :min="getMinMaxDates.minDate"
              :max="getMinMaxDates.maxDate"
            ></v-date-picker>
          </div>
        </div>
        <div class="Graphic">
          <v-progress-circular
            v-if="loading"
            style="width: 100%; text-align: center"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <GChart
            type="ColumnChart"
            :data="ChartPhases.chartData"
            :options="ChartPhases.chartOptions"
          />
          <p v-if="!loading">PHASE</p>
        </div>
      </div>
      <div class="cardBodyItem">
        <div class="TitleCardBodyItem">
          <h3>Total Hours per Proccess</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="40"
            height="5"
            viewBox="0 0 32 4"
            class="svgCardBody"
          >
            <defs>
              <linearGradient
                id="linear-gradient"
                x1="0.984"
                y1="0.154"
                x2="0"
                y2="0.823"
                gradientUnits="objectBoundingBox"
              >
                <stop offset="0" stop-color="#7467f0" />
                <stop offset="1" stop-color="#2896e9" />
              </linearGradient>
            </defs>
            <rect
              id="Rectángulo_16838"
              data-name="Rectángulo 16838"
              width="32"
              height="4"
              rx="2"
              fill="url(#linear-gradient)"
            />
          </svg>
        </div>
        <div class="cardBodyCombos">
          <p class="ElementoCombo">from</p>
          <p class="ElementoCombo">{{ pickerpfrom }}</p>
          <font-awesome-icon
            class="ElementoCombo flecha"
            icon="sort-down"
            @click="fromp = !fromp"
          />
          <div class="pickerFrom" v-if="fromp">
            <v-date-picker
              v-model="pickerpfrom"
              @input="fromp = false"
              :min="getMinMaxDates.minDate"
              :max="getMinMaxDates.maxDate"
            ></v-date-picker>
          </div>
          <p class="ElementoCombo">to</p>
          <p class="ElementoCombo">{{ pickerpto }}</p>
          <font-awesome-icon
            class="ElementoCombo flecha"
            icon="sort-down"
            @click="top = !top"
          />
          <div class="pickerFrom" v-if="top">
            <v-date-picker
              v-model="pickerpto"
              header-color="#238ef6"
              @input="top = false"
              :min="getMinMaxDates.minDate"
              :max="getMinMaxDates.maxDate"
            ></v-date-picker>
          </div>
          <ul class="DropDown">
            <li>Phase {{ Phases1Cont }}</li>
            <ul class="DropDownMenu" v-if="Phases1">
              <li
                @click="
                  (Phases1 = false), (Phases1Cont = '1'), DibujarGrafica2()
                "
              >
                Phase 1
              </li>
              <li
                @click="
                  (Phases1 = false), (Phases1Cont = '2'), DibujarGrafica2()
                "
              >
                Phase 2
              </li>
              <li
                @click="
                  (Phases1 = false), (Phases1Cont = '3'), DibujarGrafica2()
                "
              >
                Phase 3
              </li>
              <li
                @click="
                  (Phases1 = false), (Phases1Cont = '4'), DibujarGrafica2()
                "
              >
                Phase 4
              </li>
              <li
                @click="
                  (Phases1 = false), (Phases1Cont = '5'), DibujarGrafica2()
                "
              >
                Phase 5
              </li>
              <li
                @click="
                  (Phases1 = false), (Phases1Cont = '6'), DibujarGrafica2()
                "
              >
                Phase 6
              </li>
            </ul>
          </ul>
          <font-awesome-icon
            class="ElementoCombo flecha"
            icon="sort-down"
            @click="Phases1 = !Phases1"
          />
        </div>
        <div class="Graphic">
          <v-progress-circular
            v-if="loading"
            style="width: 100%; text-align: center"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <GChart
            type="BarChart"
            :data="ChartProcess.chartData"
            :options="ChartProcess.chartOptions"
          />
          <p v-if="!loading">PROCESS</p>
        </div>
      </div>
      <div class="cardBodyItem">
        <div class="TitleCardBodyItem">
          <h3>Total Hours Peer Review per Phases</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="40"
            height="5"
            viewBox="0 0 32 4"
            class="svgCardBody"
          >
            <defs>
              <linearGradient
                id="linear-gradient"
                x1="0.984"
                y1="0.154"
                x2="0"
                y2="0.823"
                gradientUnits="objectBoundingBox"
              >
                <stop offset="0" stop-color="#7467f0" />
                <stop offset="1" stop-color="#2896e9" />
              </linearGradient>
            </defs>
            <rect
              id="Rectángulo_16838"
              data-name="Rectángulo 16838"
              width="32"
              height="4"
              rx="2"
              fill="url(#linear-gradient)"
            />
          </svg>
        </div>
        <div class="Graphic">
          <v-progress-circular
            v-if="loading"
            style="width: 100%; text-align: center"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <GChart
            type="ColumnChart"
            :data="ChartPeerPhases.chartData"
            :options="ChartPeerPhases.chartOptions"
          />
          <p v-if="!loading">PHASE</p>
        </div>
      </div>
      <div class="cardBodyItem">
        <div class="TitleCardBodyItem">
          <h3>Total Hours Data Analysis per Phase</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="40"
            height="5"
            viewBox="0 0 32 4"
            class="svgCardBody"
          >
            <defs>
              <linearGradient
                id="linear-gradient"
                x1="0.984"
                y1="0.154"
                x2="0"
                y2="0.823"
                gradientUnits="objectBoundingBox"
              >
                <stop offset="0" stop-color="#7467f0" />
                <stop offset="1" stop-color="#2896e9" />
              </linearGradient>
            </defs>
            <rect
              id="Rectángulo_16838"
              data-name="Rectángulo 16838"
              width="32"
              height="4"
              rx="2"
              fill="url(#linear-gradient)"
            />
          </svg>
        </div>
        <div class="Graphic">
          <v-progress-circular
            v-if="loading"
            style="width: 100%; text-align: center"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <GChart
            type="ColumnChart"
            :data="ChartAnalysisPhases.chartData"
            :options="ChartAnalysisPhases.chartOptions"
          />
          <p v-if="!loading">PHASE</p>
        </div>
      </div>
      <div class="cardBodyItem">
        <div class="TitleCardBodyItem">
          <h3>Total Hours Peer Review per Process</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="40"
            height="5"
            viewBox="0 0 32 4"
            class="svgCardBody"
          >
            <defs>
              <linearGradient
                id="linear-gradient"
                x1="0.984"
                y1="0.154"
                x2="0"
                y2="0.823"
                gradientUnits="objectBoundingBox"
              >
                <stop offset="0" stop-color="#7467f0" />
                <stop offset="1" stop-color="#2896e9" />
              </linearGradient>
            </defs>
            <rect
              id="Rectángulo_16838"
              data-name="Rectángulo 16838"
              width="32"
              height="4"
              rx="2"
              fill="url(#linear-gradient)"
            />
          </svg>
        </div>
        <div class="cardBodyCombos">
          <ul class="DropDown">
            <li>Phase {{ Phases2Cont }}</li>
            <ul class="DropDownMenu" v-if="Phases2">
              <li
                @click="
                  (Phases2 = false), (Phases2Cont = '1'), DibujarGrafica5()
                "
              >
                Phase 1
              </li>
              <li
                @click="
                  (Phases2 = false), (Phases2Cont = '2'), DibujarGrafica5()
                "
              >
                Phase 2
              </li>
              <li
                @click="
                  (Phases2 = false), (Phases2Cont = '3'), DibujarGrafica5()
                "
              >
                Phase 3
              </li>
              <li
                @click="
                  (Phases2 = false), (Phases2Cont = '4'), DibujarGrafica5()
                "
              >
                Phase 4
              </li>
              <li
                @click="
                  (Phases2 = false), (Phases2Cont = '5'), DibujarGrafica5()
                "
              >
                Phase 5
              </li>
              <li
                @click="
                  (Phases2 = false), (Phases2Cont = '6'), DibujarGrafica5()
                "
              >
                Phase 6
              </li>
            </ul>
          </ul>
          <font-awesome-icon
            class="ElementoCombo flecha"
            icon="sort-down"
            @click="Phases2 = !Phases2"
          />
        </div>
        <div class="Graphic">
          <v-progress-circular
            v-if="loading"
            style="width: 100%; text-align: center"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <GChart
            type="BarChart"
            :data="ChartPeerProcess.chartData"
            :options="ChartPeerProcess.chartOptions"
          />
          <p v-if="!loading">PHASE</p>
        </div>
      </div>
      <div class="cardBodyItem">
        <div class="TitleCardBodyItem">
          <h3>Total Hours Data Analysis per Process</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="40"
            height="5"
            viewBox="0 0 32 4"
            class="svgCardBody"
          >
            <defs>
              <linearGradient
                id="linear-gradient"
                x1="0.984"
                y1="0.154"
                x2="0"
                y2="0.823"
                gradientUnits="objectBoundingBox"
              >
                <stop offset="0" stop-color="#7467f0" />
                <stop offset="1" stop-color="#2896e9" />
              </linearGradient>
            </defs>
            <rect
              id="Rectángulo_16838"
              data-name="Rectángulo 16838"
              width="32"
              height="4"
              rx="2"
              fill="url(#linear-gradient)"
            />
          </svg>
        </div>
        <div class="cardBodyCombos">
          <ul class="DropDown">
            <li>Phase {{ Phases3Cont }}</li>
            <ul class="DropDownMenu" v-if="Phases3">
              <li
                @click="
                  (Phases3 = false), (Phases3Cont = '1'), DibujarGrafica6()
                "
              >
                Phase 1
              </li>
              <li
                @click="
                  (Phases3 = false), (Phases3Cont = '2'), DibujarGrafica6()
                "
              >
                Phase 2
              </li>
              <li
                @click="
                  (Phases3 = false), (Phases3Cont = '3'), DibujarGrafica6()
                "
              >
                Phase 3
              </li>
              <li
                @click="
                  (Phases3 = false), (Phases3Cont = '4'), DibujarGrafica6()
                "
              >
                Phase 4
              </li>
              <li
                @click="
                  (Phases3 = false), (Phases3Cont = '5'), DibujarGrafica6()
                "
              >
                Phase 5
              </li>
              <li
                @click="
                  (Phases3 = false), (Phases3Cont = '6'), DibujarGrafica6()
                "
              >
                Phase 6
              </li>
            </ul>
          </ul>
          <font-awesome-icon
            class="ElementoCombo flecha"
            icon="sort-down"
            @click="Phases3 = !Phases3"
          />
        </div>
        <div class="Graphic">
          <v-progress-circular
            v-if="loading"
            style="width: 100%; text-align: center"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <GChart
            type="BarChart"
            :data="ChartDataAnalysis.chartData"
            :options="ChartDataAnalysis.chartOptions"
          />
          <p v-if="!loading">PROCESS</p>
        </div>
      </div>
      <div class="cardBodyItem Button">
        <!-- <button class="Download">Download Report</button> -->
        <button class="Download">
          <a
            style="color: white"
            :href="`${publicPath}Pampa_Project Time Report April 20 2021_up.xlsx`"
            download
            >Download Report</a
          >
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    publicPath: process.env.BASE_URL,
    pickerhffrom: new Date("2021/01/14").toISOString().substr(0, 10),
    pickerhffromf: "2021/01/14",
    pickerhfto: new Date("2021/04/21").toISOString().substr(0, 10),
    pickerhftof: "2021/04/21",
    fromhf: false,
    tohf: false,
    pickerpfrom: new Date("2021/01/14").toISOString().substr(0, 10),
    pickerpfromf: "2021/01/14",
    pickerpto: new Date("2021/04/21").toISOString().substr(0, 10),
    pickerptof: "2021/04/21",
    fromp: false,
    top: false,
    Phases1: false,
    Phases2: false,
    Phases3: false,
    loading: true,
    Phases1Cont: "1",
    Phases2Cont: "1",
    Phases3Cont: "1",
    grafico1: ["Phase", "h", { role: "style" }, { role: "annotation" }],
    ChartPhases: {
      chartData: [
        ["Phase", "h", { role: "style" }, { role: "annotation" }],
        ["1", 0, "color: #7FAEE2; opacity: 0.6;", "0"],
        ["2", 0, "color: #F68B23; opacity: 0.6;", "0"],
        ["3", 0, "color: #4D74BB; opacity: 0.6;", "0"],
        ["4", 0, "color: #9DCDFB; opacity: 0.6;", "0"],
        ["5", 0, "color: #7FAEE2; opacity: 0.6;", "0"],
        ["6", 0, "color: #4472C4; opacity: 0.6;", "0"],
      ],
      chartOptions: {
        title: "Hours per Phase",
        legend: { position: "none" },
        bar: { groupWidth: "95%" },
      },
    },
    chartData: [
      ["Phase", "h", { role: "style" }, { role: "annotation" }],
      ["1", 0, "color: #7FAEE2; opacity: 0.6;", "0"],
      ["2", 0, "color: #F68B23; opacity: 0.6;", "0"],
      ["3", 0, "color: #4D74BB; opacity: 0.6;", "0"],
      ["4", 0, "color: #9DCDFB; opacity: 0.6;", "0"],
      ["5", 0, "color: #7FAEE2; opacity: 0.6;", "0"],
      ["6", 0, "color: #4472C4; opacity: 0.6;", "0"],
    ],
    ChartProcess: {
      chartData: [
        ["Process", "h", { role: "style" }, { role: "annotation" }],
        ["4.1", 2, "color: #7FAEE2; opacity: 0.6;", "2"],
        ["4.2", 1, "color: #F68B23; opacity: 0.6;", "1"],
        ["4.3", 3, "color: #4D74BB; opacity: 0.6;", "3"],
      ],
      chartOptions: {
        title: "Hours per Phase",
        legend: { position: "none" },
        bar: { groupWidth: "95%" },
        bars: "horizontal",
      },
    },
    chartDataProcess: [
      ["Process", "h", { role: "style" }, { role: "annotation" }],
      ["1.1", 0, "color: #7FAEE2; opacity: 0.6;", "0"],
      ["1.3", 0, "color: #F68B23; opacity: 0.6;", "0"],
      ["1.2", 0, "color: #4D74BB; opacity: 0.6;", "0"],
    ],
    ChartPeerPhases: {
      chartData: [
        ["Phase", "h", { role: "style" }, { role: "annotation" }],
        ["1", 5, "color: #7FAEE2; opacity: 0.6;", "5"],
        ["2", 3, "color: #F68B23; opacity: 0.6;", "3"],
        ["3", 2, "color: #4D74BB; opacity: 0.6;", "2"],
        ["4", 0, "color: #9DCDFB; opacity: 0.6;", "0"],
        ["5", 0, "color: #7FAEE2; opacity: 0.6;", "0"],
        ["6", 0, "color: #4472C4; opacity: 0.6;", "0"],
      ],
      chartOptions: {
        title: "Hours per Phase",
        legend: { position: "none" },
        bar: { groupWidth: "95%" },
        bars: "horizontal",
      },
    },
    ChartAnalysisPhases: {
      chartData: [
        ["Phase", "h", { role: "style" }, { role: "annotation" }],
        ["1", 10, "color: #7FAEE2; opacity: 0.6;", "10"],
        ["2", 6, "color: #F68B23; opacity: 0.6;", "6"],
        ["3", 4, "color: #4D74BB; opacity: 0.6;", "4"],
        ["4", 0, "color: #9DCDFB; opacity: 0.6;", "0"],
        ["5", 0, "color: #7FAEE2; opacity: 0.6;", "0"],
        ["6", 0, "color: #4472C4; opacity: 0.6;", "0"],
      ],
      chartOptions: {
        title: "Hours per Phase",
        legend: { position: "none" },
        bar: { groupWidth: "95%" },
        bars: "horizontal",
      },
    },
    ChartPeerProcess: {
      chartData: [
        ["Process", "h", { role: "style" }, { role: "annotation" }],
        ["4.1", 2, "color: #7FAEE2; opacity: 0.6;", "2"],
        ["4.2", 1, "color: #F68B23; opacity: 0.6;", "1"],
        ["4.3", 3, "color: #4D74BB; opacity: 0.6;", "3"],
      ],
      chartOptions: {
        title: "Hours per Phase",
        legend: { position: "none" },
        bar: { groupWidth: "95%" },
        bars: "horizontal",
      },
    },
    ChartDataAnalysis: {
      chartData: [
        ["Process", "h", { role: "style" }, { role: "annotation" }],
        ["4.1", 5, "color: #7FAEE2; opacity: 0.6;", "5"],
        ["4.2", 3, "color: #F68B23; opacity: 0.6;", "3"],
        ["4.3", 2, "color: #4D74BB; opacity: 0.6;", "2"],
      ],
      chartOptions: {
        title: "Hours per Phase",
        legend: { position: "none" },
        bar: { groupWidth: "95%" },
        bars: "horizontal",
      },
    },
  }),
  methods: {
    close() {
      this.$emit("close", this.name);
    },
    onChartReady(chart, google) {
      this.chartsLib = google;
    },
    cargar(valor) {
      if (valor) {
        const colores = [
          "color: #7FAEE2; opacity: 0.6;",
          "color: #F68B23; opacity: 0.6;",
          "color: #4D74BB; opacity: 0.6;",
          "color: #9DCDFB; opacity: 0.6;",
          "color: #7FAEE2; opacity: 0.6;",
          "color: #4472C4; opacity: 0.6;",
        ];

        for (let step = 0; step < valor.length; step++) {
          let longcolores = step;
          valor[step].push(colores[longcolores]);
          if (longcolores > colores.length) {
            longcolores = 0;
          }
        }
        return valor;
      }
    },
    label(valor) {
      if (valor) {
        for (let step = 0; step < valor.length; step++) {
          valor[step].push(valor[step][1].toString());
        }
        return valor;
      }
    },
    DibujarGrafica1() {
      let query = {
        fechaInicial: this.pickerhffromf,
        fechaFinal: this.pickerhftof,
        phase: "",
        procces: "Phase",
        Peer: true,
        Data: true,
      };

      let datos = this.obtenerDatosporfecha(query);
      if (datos.length != 0) {
        datos = this.cargar(datos);
        datos = this.label(datos);
        this.ChartPhases.chartData = [this.grafico1, ...datos];
      } else {
        this.ChartPhases.chartData = this.chartData;
      }
    },
    cargar2(valor) {
      if (valor) {
        const colores = [
          "color: #7FAEE2; opacity: 0.6;",
          "color: #F68B23; opacity: 0.6;",
          "color: #4D74BB; opacity: 0.6;",
          "color: #9DCDFB; opacity: 0.6;",
          "color: #7FAEE2; opacity: 0.6;",
          "color: #4472C4; opacity: 0.6;",
        ];

        for (let step = 0; step < valor.length; step++) {
          let longcolores = step;
          valor[step].push(colores[longcolores]);
          if (longcolores > colores.length) {
            longcolores = 0;
          }
        }
        return valor;
      }
    },
    label2(valor) {
      if (valor) {
        for (let step = 0; step < valor.length; step++) {
          valor[step].push(valor[step][1].toString());
        }
        return valor;
      }
    },
    DibujarGrafica2() {
      let query = {
        fechaInicial: this.pickerpfromf,
        fechaFinal: this.pickerptof,
        phase: this.Phases1Cont,
        procces: "Process",
        Peer: true,
        Data: true,
      };

      let datos = this.obtenerDatosporfecha(query);
      if (datos.length != 0) {
        datos = this.cargar2(datos);
        datos = this.label2(datos);
        this.ChartProcess.chartData = [this.grafico1, ...datos];
      } else {
        this.ChartProcess.chartData = this.chartDataProcess;
      }
    },
    cargar3(valor) {
      if (valor) {
        const colores = [
          "color: #7FAEE2; opacity: 0.6;",
          "color: #F68B23; opacity: 0.6;",
          "color: #4D74BB; opacity: 0.6;",
          "color: #9DCDFB; opacity: 0.6;",
          "color: #7FAEE2; opacity: 0.6;",
          "color: #4472C4; opacity: 0.6;",
        ];

        for (let step = 0; step < valor.length; step++) {
          let longcolores = step;
          valor[step].push(colores[longcolores]);
          if (longcolores > colores.length) {
            longcolores = 0;
          }
        }
        return valor;
      }
    },
    label3(valor) {
      if (valor) {
        for (let step = 0; step < valor.length; step++) {
          valor[step].push(valor[step][1].toString());
        }
        return valor;
      }
    },
    DibujarGrafica3() {
      let query = {
        fechaInicial: undefined,
        fechaFinal: undefined,
        phase: "",
        procces: "Phase",
        Peer: true,
        Data: false,
      };
      let datos = this.cargar3(this.obtenerDatosporfecha(query));
      datos = this.label3(datos);
      this.ChartPeerPhases.chartData = [this.grafico1, ...datos];
    },
    cargar4(valor) {
      if (valor) {
        const colores = [
          "color: #7FAEE2; opacity: 0.6;",
          "color: #F68B23; opacity: 0.6;",
          "color: #4D74BB; opacity: 0.6;",
          "color: #9DCDFB; opacity: 0.6;",
          "color: #7FAEE2; opacity: 0.6;",
          "color: #4472C4; opacity: 0.6;",
        ];

        for (let step = 0; step < valor.length; step++) {
          let longcolores = step;
          valor[step].push(colores[longcolores]);
          if (longcolores > colores.length) {
            longcolores = 0;
          }
        }
        return valor;
      }
    },
    label4(valor) {
      if (valor) {
        for (let step = 0; step < valor.length; step++) {
          valor[step].push(valor[step][1].toString());
        }
        return valor;
      }
    },
    DibujarGrafica4() {
      let query = {
        fechaInicial: undefined,
        fechaFinal: undefined,
        phase: "",
        procces: "Phase",
        Peer: false,
        Data: true,
      };
      let datos = this.cargar4(this.obtenerDatosporfecha(query));
      datos = this.label4(datos);
      this.ChartAnalysisPhases.chartData = [this.grafico1, ...datos];
    },
    cargar5(valor) {
      if (valor) {
        const colores = [
          "color: #7FAEE2; opacity: 0.6;",
          "color: #F68B23; opacity: 0.6;",
          "color: #4D74BB; opacity: 0.6;",
          "color: #9DCDFB; opacity: 0.6;",
          "color: #7FAEE2; opacity: 0.6;",
          "color: #4472C4; opacity: 0.6;",
        ];

        for (let step = 0; step < valor.length; step++) {
          let longcolores = step;
          valor[step].push(colores[longcolores]);
          if (longcolores > colores.length) {
            longcolores = 0;
          }
        }
        return valor;
      }
    },
    label5(valor) {
      if (valor) {
        for (let step = 0; step < valor.length; step++) {
          valor[step].push(valor[step][1].toString());
        }
        return valor;
      }
    },
    DibujarGrafica5() {
      let query = {
        fechaInicial: undefined,
        fechaFinal: undefined,
        phase: this.Phases2Cont,
        procces: "Process",
        Peer: true,
        Data: false,
      };
      let datos = this.cargar4(this.obtenerDatosporfecha(query));
      datos = this.label4(datos);
      this.ChartPeerProcess.chartData = [this.grafico1, ...datos];
    },
    cargar6(valor) {
      if (valor) {
        const colores = [
          "color: #7FAEE2; opacity: 0.6;",
          "color: #F68B23; opacity: 0.6;",
          "color: #4D74BB; opacity: 0.6;",
          "color: #9DCDFB; opacity: 0.6;",
          "color: #7FAEE2; opacity: 0.6;",
          "color: #4472C4; opacity: 0.6;",
        ];

        for (let step = 0; step < valor.length; step++) {
          let longcolores = step;
          valor[step].push(colores[longcolores]);
          if (longcolores > colores.length) {
            longcolores = 0;
          }
        }
        return valor;
      }
    },
    label6(valor) {
      if (valor) {
        for (let step = 0; step < valor.length; step++) {
          valor[step].push(valor[step][1].toString());
        }
        return valor;
      }
    },
    DibujarGrafica6() {
      let query = {
        fechaInicial: undefined,
        fechaFinal: undefined,
        phase: this.Phases3Cont,
        procces: "Process",
        Peer: false,
        Data: true,
      };
      let datos = this.cargar6(this.obtenerDatosporfecha(query));
      datos = this.label6(datos);
      this.ChartDataAnalysis.chartData = [this.grafico1, ...datos];
    },
  },
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  components: {
    GChart,
  },
  computed: {
    ...mapState(["projects"]),
    ...mapGetters("Statistics", ["obtenerDatosporfecha", "getMinMaxDates"]),
  },
  watch: {
    //cambiando las variables de los picker para pasarlos a las funciones PICKER FROM 1
    pickerhffrom: function (value) {
      const valor = value.split("-");
      value = valor[0] + "/" + valor[1] + "/" + valor[2];
      this.pickerhffromf = value;
      this.DibujarGrafica1();
    },
    //cambiando las variables de los picker para pasarlos a las funciones PICKER TO 1
    pickerhfto: function (value) {
      const valor = value.split("-");
      value = valor[0] + "/" + valor[1] + "/" + valor[2];
      this.pickerhftof = value;
      this.DibujarGrafica1();
    },
    //cambiando las variables de los picker para pasarlos a las funciones PICKER FROM 2
    pickerpfrom: function (value) {
      const valor = value.split("-");
      value = valor[0] + "/" + valor[1] + "/" + valor[2];
      this.pickerpfromf = value;
      this.DibujarGrafica2();
    },
    //cambiando las variables de los picker para pasarlos a las funciones PICKER TO 2
    pickerpto: function (value) {
      const valor = value.split("-");
      value = valor[0] + "/" + valor[1] + "/" + valor[2];
      this.pickerptof = value;
      this.DibujarGrafica2();
    },
  },
  created() {
    this.DibujarGrafica1();
    this.DibujarGrafica2();
    this.DibujarGrafica3();
    this.DibujarGrafica4();
    this.DibujarGrafica5();
    this.DibujarGrafica6();
  },
  mounted() {
    setTimeout(() => (this.loading = false), 700);
  },
};
</script>

<style lang="css" scoped>
/************* TARGETA ESTADISTICAS************/
.card {
  background: white;
  overflow-y: auto;
}
/************* TARGETAS DE ESTADISTICAS DE SUPERIORES ************/
.header {
  margin: 20px;
  position: relative;
}
.header .Title {
  display: flex;
  justify-content: center;
  color: var(--sixth-color);
}
.header .x {
  position: absolute;
  right: 5px;
  top: 5px;
  color: var(--sixth-color);
  font-size: 20px;
}
.cardHeader {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.cardHeaderItem {
  background: white;
  display: flex;
  box-shadow: 0px 10px 15px -8px #c1c1c1;
  margin: 5px;
  width: 300px;
  border-radius: 10px;
}
.cardHeaderItem .icono {
  width: 30%;
  font-size: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cardHeaderItem .icono div {
  height: 60px;
  width: 65px;
  border-radius: 15px;
  background: rgb(71, 141, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.BodyItem {
  width: 70%;
  display: flex;
  flex-direction: column;
}
.TitleItem {
  width: 100%;
  color: var(--sixth-color);
  text-align: center;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  margin-top: 10px;
}
.BodyValues {
  display: flex;
  flex-direction: row;
  position: relative;
}
.BodyValues .Value {
  font-family: Montserrat, sans-serif;
  font-weight: 550;
  font-size: 25px;
  position: absolute;
  top: -15px;
  left: 15px;
}
.BodyValues .Percent {
  font-family: Montserrat, sans-serif;
  font-weight: lighter;
  position: absolute;
  top: -20px;
  right: 15px;
}
.DropDown {
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  list-style: none;
  position: relative;
  font-size: 10px;
  padding: 0px !important;
}
.DropDownMenu {
  list-style: none;
  position: absolute;
  left: -10px;
  z-index: 5;
  width: 120px;
}
.DropDownMenu li {
  box-shadow: 0px 0px 2px 0px #c1c1c1;
  background: white;
  text-align: center;
  padding: 5px;
}

/************* TARGETAS CON GRAFICOS INFERIORES ************/
.cardBody {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.cardBodyItem {
  width: 320px;
  box-shadow: 0px 10px 20px 0px #c1c1c1;
  border-radius: 15px;
  margin: 10px;
}
.TitleCardBodyItem {
  margin: 10px;
}

.TitleCardBodyItem h3 {
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  font-size: 18px;
}

.cardBodyCombos {
  margin: 20px;
  display: flex;
  flex-direction: row;
  margin: 5px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  justify-content: center;
}
.cardBodyCombos p {
  font-size: 12px;
  margin-left: 5px;
  margin-top: -2px;
}
.cardBodyCombos .flecha {
  margin-top: -5px;
  color: #c1c1c1;
}
.svgCardBody {
  position: absolute;
}
.ElementoCombo {
  margin: 3px;
  font-size: 15px;
}
.Graphic {
  position: relative;
  z-index: 0;
  margin: auto;
}
.Graphic p {
  position: relative;
  text-align: center;
  font-size: 15px;
  font-family: Montserrat, sans-serif;
  font-weight: bold;
  margin-top: -15px;
  z-index: 1;
}
.pickerFrom {
  position: absolute;
  top: 0px;
  z-index: 1;
  transform: scale(0.6);
}
/*************ARREGLANDO BOTON DE FONDO ************* */
.Button {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.Download {
  background: #238ef6;
  padding: 10px;
  outline: none;
  text-align: center;
  height: 50px;
  margin: 20px;
  color: #fff;
  border-radius: 10px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
}
@media (max-width: 1407px) {
  .cardHeaderItem {
    transform: scale(0.8);
    margin-left: -20px;
    margin-right: -20px;
  }
}
@media (max-width: 573px) {
  .cardHeaderItem {
    transform: scale(0.6);
    margin-left: -55px;
    margin-right: -55px;
    margin-bottom: -20px;
  }
}
@media (max-width: 429px) {
  .cardHeaderItem {
    transform: scale(0.8);
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: -15px;
  }
  .cardBodyItem {
    width: 320px;
  }
}
@media (max-width: 385px) {
  .cardBodyItem {
    width: 300px;
  }
  .DropDownMenu {
    width: 80px;
  }
}
@media (max-width: 364px) {
  .cardBodyItem {
    width: 280px;
  }
}
@media (max-width: 341px) {
  .cardBodyItem {
    width: 250px;
  }
}
</style>